<template>
  <div class="second_item">
    <div class="second_item_left" v-if="data">
      <div class="second_item_left_img">
        <img :src="data.member.avatar"/>
      </div>
      <div class="second_item_left_msg">
        <span class="user_name">{{data.member.nickname}}</span>赞了我的作品<span v-if="data.type == 'POST_COMMENT'||data.type == 'ARTICLE_COMMENT'">评论</span>
      </div>
      <div class="second_item_left_time">{{getTime(data.createdDate)}}</div>
      <div class="second_item_left_delete" @click="toDeleteFun(true)">删除</div>
    </div>
    <div class="second_item_right" @click="toDetailsFun">
      <div class="second_item_right_img">
        <img :src="data.post.images[0]" v-if="data.type == 'POST'||data.type == 'POST_COMMENT'"/>
        <img :src="data.article.images[0]" v-if="data.type == 'ARTICLE'||data.type == 'ARTICLE_COMMENT'"/>
      </div>
    </div>
    <div class="second_item_delete_pop" v-if="deleteState">
      <div class="title">通知を削除しますか？</div>
      <div class="pop_btn">
        <div class="pop_btn_item" @click="deleteFun()">確認</div>
        <div class="pop_btn_item" @click="toDeleteFun(false)">キャンセル</div>
      </div>
    </div>
    <post-dialog v-if="detailsDialog" :detailsDialog.sync="detailsDialog" :postList="postList" :videoList="postList" :state="state"></post-dialog>
  </div>
</template>

<script>
import { timeToStr,isEmptyObject } from '@/assets/js/util'
import postDialog from '@/components/Dialog'
import * as json from '@/assets/js/json'
export default {
  components: {
    postDialog
  },
  props:{
    data:{
      type:Object,
      default: null
    }
  },
  data () {
    return{
      deleteState: false,
      detailsDialog: false,
      postList: {},
      state: 'post'
    }
  },
  created () {
    console.log(this.data)
  },
  methods: {
    toDeleteFun(state){
      this.deleteState = state
    },
    deleteFun(){
      const user = this.$store.state.userInfo
      const cacheLikeMsg = this.$store.state.likeMsg
      let list = []
      if (!isEmptyObject(cacheLikeMsg)) {
        console.log(cacheLikeMsg[user.id])
        for (let i = 0; i < cacheLikeMsg[user.id].length; i++) {
          if(this.data.createdDate != cacheLikeMsg[user.id][i].createdDate){
            list.push(cacheLikeMsg[user.id][i])
          }
        }
        cacheLikeMsg[user.id] = list
        this.$store.commit('SET_UNREAD_LIKE_MSG', cacheLikeMsg)
        this.$notify({
          title: '注意',
          message: '删除成功',
          type: 'success'
        });
        this.$parent.fetch()
        this.toDeleteFun(false)
      }
    },
    toDetailsFun(){
      if(this.data.type == 'POST'||this.data.type == 'POST_COMMENT'){
        this.detailsDialog = true
        this.postList = this.data.post
        this.state = this.postList.videoUrl?'video':'post'
      }else if(this.data.type == 'ARTICLE'||this.data.type == 'ARTICLE_COMMENT'){
        this.$router.push('/article?articleId=' + this.data.article.id)
      }
    },
    getTime(time){  
      return timeToStr(time)
    },
  }
}
</script>
<style scoped>
  .second_item{
  width: 770px;
  height: 80px;
  margin: 0 auto;
  margin-top: 28px;
  padding-bottom: 28px;
  position: relative;
  border-bottom: 1px solid #EBEBEB;
}
.second_item_left{
  position: relative;
  height: 80px;
}
.second_item_left_img{
  width: 55px;
  height: 55px;
  position: absolute;
  top: 10px;
  left: 0px;
}
.second_item_left_img img{
  width: 55px;
  height: 55px;
  border-radius: 50%;
}
.second_item_left_msg{
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  line-height: 16px;
  position: absolute;
  left: 70px;
  top: 3px;
}
.second_item_left_msg .user_name{
  color: #3399CC;
  margin-right: 16px;
}
.second_item_left_time{
  font-size: 14px;
  font-weight: 300;
  color: #666666;
  line-height: 14px;
  position: absolute;
  top: 48px;
  left: 71px;
}
.second_item_left_delete{
  position: absolute;
  top: 48px;
  left: 181px;
  font-size: 14px;
  color: #666666;
  line-height: 14px;
  cursor: pointer;
}
.second_item_right{
  position: absolute;
  top: 0px;
  right: 0px;
  cursor: pointer;
}
.second_item_right_img{
  width: 80px;
  height: 80px;
}
.second_item_right_img img{
  width: 80px;
  height: 80px;
  background: #DDDDDD;
  border-radius: 10px;
}
.second_item_delete_pop{
  width: 172px;
  height: 77px;
  background: #FFFFFF;
  box-shadow: 0px 2px 10px 0px rgba(0,0,0,0.1);
  border-radius: 5px;
  position: absolute;
  top: 45px;
  left: 213px;
}
.second_item_delete_pop .title{
  font-size: 14px;
  font-weight: 300;
  color: #666666;
  line-height: 14px;
  text-align: center;
  margin-top: 14px;
}
.pop_btn{
  width: 100%;
  margin-top: 14px;
  font-size: 12px;
  font-weight: 300;
  color: #666666;
  text-align: center;
}
.pop_btn_item{
  display: inline-block;
  width: 73px;
  height: 20px;
  line-height: 20px;
  background: #F6F6F6;
  border-radius: 5px;
  margin: 0 auto;
  cursor: pointer;
}
.pop_btn_item:last-child{
  margin-left: 8px;
}
</style>